<template>
  <div>
    <el-select
      :value="value"
      size="small"
      filterable
      remote
      @change="handleChange"
      :remote-method="requestData"
      :loading="loading"
      placeholder="搜索并选择"
      style="width: 100%"
      ref="itemSelect"
    >
      <el-option
        v-for="item in lists"
        :key="item.id"
        :label="`${item.code}（${item.name}，${item.specification}，${item.model_number}）`"
        :value="item.id"
      ></el-option>
    </el-select>

    <div class="font-12 text-info mt-5" style="line-height: 1em">
      {{
        `选项格式为：编码（名称，规格，${
          commodityCategory == 2 ? '倒角' : '型号'
        }）`
      }}
    </div>
  </div>
</template>

<script>
import { itemList } from '../../service/getData'

export default {
  props: {
    value: '',
    commodityCategory: Number,
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  created() {
    if (this.value) {
      this.requestData('', this.value)
    }
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData(query, defaultValue = 0) {
      if (query !== '' || defaultValue) {
        this.loading = true
        let data = {
          query: query,
          item_id: defaultValue,
          commodity_category: this.commodityCategory,
        }
        let res = await itemList(data)
        this.loading = false
        this.lists = res.data.list
      } else {
        this.lists = []
      }
    },
  },
}
</script>